module.exports = __webpack_public_path__ + "img/9S.6318c689.svg";